import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGiftCardinline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 64,
	height: 64,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeWidth: 2,
		stroke: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M29 63v-4c-5.333-9.333-8-14.667-8-16 0-1.333.667-3.333 2-6" }),
			/* @__PURE__ */ _jsxs("g", {
				strokeLinejoin: "round",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M30.621 37.018L15 37c-1.74 0-3-1.76-3-3.5V13.803C12 12.063 13.26 11 15 11h29.927C46.668 11 48 12.429 48 14.17v19.696C48 35.606 46.668 37 44.927 37H40",
						strokeLinecap: "square"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M23 27l4-4m4 4l-4-4m0-4.457L20 16v9l7-2.35zm0 0L34 16v9l-7-2.35z",
						strokeLinecap: "square"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M13.355 20h6.158M27 11v26m7.395-17h13",
						strokeLinecap: "round"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", { d: "M29 45l3-4V31c0-2.667 1.333-4 4-4s4 1.333 4 4v10c2 4 3 7 3 9s-1 5-3 9v4" })
		]
	})
});
export default SvgGiftCardinline;
